var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 753,
    height: 752,
    viewBox: "0 0 753 752",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M752.493 376.457C752.493 583.864 584.041 752 376.246 752C168.451 752 0 583.864 0 376.457C0 320.2 13.7995 254.174 36.0092 206.267C56.3111 162.475 130.104 224.738 185.662 172.123C241.22 119.508 178.685 48.8698 225.044 31.1796C266.762 15.2607 328.923 0.914062 376.246 0.914062C584.041 0.914062 752.493 169.05 752.493 376.457Z",
    fill: "url(#paint0_linear_34_32)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M733.5 376.5C733.5 573.665 573.442 733.5 376 733.5C178.558 733.5 18.5 573.665 18.5 376.5C18.5 322.991 27.6243 264.215 48.7166 218.697C51.0955 213.563 54.1807 210.136 57.8619 207.92C61.5487 205.701 65.871 204.676 70.7577 204.412C75.6475 204.148 81.0767 204.646 86.9618 205.456C90.1016 205.888 93.3383 206.402 96.685 206.935C99.6404 207.405 102.682 207.889 105.817 208.341C119.122 210.26 133.779 211.552 148.932 208.464C164.098 205.373 179.735 197.9 195.015 182.334C225.587 151.188 225.672 120.173 223.667 94.9292C223.479 92.5581 223.273 90.2419 223.072 87.9839C222.201 78.1962 221.427 69.5026 222.622 62.182C223.354 57.6976 224.822 53.7636 227.444 50.4366C230.064 47.1107 233.862 44.358 239.309 42.2786C278.933 27.1513 331.016 19.5 376 19.5C573.442 19.5 733.5 179.335 733.5 376.5Z",
    stroke: "#46B6FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_32",
    x1: 669.713,
    y1: 9116.3,
    x2: 79.9144,
    y2: -8512.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#187CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#128FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0CA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#06C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DBFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.278b6d3c568ad955b7e62470369d40c7.svg";
export { ForwardRef as ReactComponent };